var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0478 15.7479V9.60088H12.1215L12.4298 7.19413H10.0478V5.66113C10.0478 4.96663 10.2413 4.49113 11.238 4.49113H12.501V2.34538C11.8865 2.27952 11.2688 2.24772 10.6508 2.25013C8.81777 2.25013 7.55927 3.36913 7.55927 5.42338V7.18963H5.49902V9.59638H7.56377V15.7479H10.0478Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e0cbf1c4d12aa124d1d99df06b162368.svg";
export { ForwardRef as ReactComponent };